const API_BASE = process.env.GATSBY_API_URL || "https://localhost:5001"

export const apiFetch = async (path, options = {}) => {
  const headers = { ...(options.headers || {}) }

  if (headers["Content-Type"] === undefined && options.body) {
    headers["Content-Type"] = "application/json"
  }

  if (typeof window !== "undefined") {
    const token = localStorage.getItem("token")
    if (token) {
      headers.Authorization = `Bearer ${token}`
    }
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  })

  const text = await res.text()
  const data = text ? JSON.parse(text) : null

  if (!res.ok) {
    throw new Error(data?.message || "Request failed")
  }

  return data
}

export default API_BASE
